import React from "react";
import Hero from "./Hero";
import Reach from "./Reach";

function ContactUs() {
  return (
    <>
      <Hero />
      <Reach />
    </>
  );
}

export default ContactUs;
